import useApi from '../../common/hooks/useApi'
import useSWR from 'swr'
import { type Currency } from '@amici/myamici-api-client'

interface UseCurrencyHook {
  currencies: Currency[] | undefined
  isLoading: boolean
  hasData: boolean
  loadingError: any
}

function useCurrencies (): UseCurrencyHook {
  const { metadataApi, fetcherWithoutParams } = useApi()

  const {
    data,
    isLoading,
    error: loadingError
  } = useSWR(
    'allCurrencies',
    async () => await fetcherWithoutParams(metadataApi.getAllActiveCurrencies())
  )

  const hasData = Array.isArray(data) && data.length > 0

  return {
    currencies: data,
    isLoading,
    hasData,
    loadingError
  }
}

export default useCurrencies
